module.exports = __webpack_public_path__ + "static/image_18-ff451831cf2008b25825dd00c0e319c0.jpg";